import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LibellesService } from 'src/app/core/libelles.service';
import { Modalite, ModalitesService } from 'src/app/core/modalites.service';
import { AlertesService } from 'src/app/shared/alertes.service';
import { FormulaireService } from '../../formulaire.service';
import { ModeRenduService } from '../../mode-rendu/mode-rendu.service';
import { SaisieService } from '../../saisie.service';

@Component({
  selector: 'bis-synthese-bav',
  templateUrl: './synthese-bav.component.html',
  styleUrls: ['./synthese-bav.component.css']
})
export class SyntheseBavComponent implements OnInit, OnDestroy {
  @Input()
  erreursMap: Map<string, string>;
  public rootForm: UntypedFormGroup;

  private modalites: Modalite[] = [];
  private subscriptions: Subscription[] = [];
  public libelleJuridiction: string = '';
  
  public infobulle1: string = 'Assignation à résidence sous surveillance électronique';

  constructor(
    private formulaireService: FormulaireService,
    public alertesService: AlertesService,
    public modeRendu: ModeRenduService,
    public modaliteService: ModalitesService,
    public libelleService: LibellesService,
    public saisieService: SaisieService
    
  ) { this.rootForm = this.formulaireService.getRootForm();
    if (! this.detailBavs) {
      (this.rootForm.get('bav') as UntypedFormGroup).setControl('detailBavs', new UntypedFormArray([]));
    }}

  ngOnInit(): void {
    // Recup AAV concernée
    this.subscriptions.push(
      this.modaliteService.getModalites('ielst').subscribe(modalites => {
        this.modalites = modalites;
        // Après la mise à jour des modalités, on met à jour la valeur au cas où
        this.libelleJuridiction = this.saisieService.gestionLibelle(this.identifiantJuridictionValeur, this.modalites);
      })
    );

    // Calcul auto de la synthèse et Envoi des calculs réalisés à la BDD 
    // console.log('form', this.detailBavs);
    this.saisieService.majsSynthese(this.formulaire, this.detailBavs);
  }

  ngOnDestroy() {
    /** Quand le composant est détruit, on arrête de surveiller les changements de valeurs */
    this.subscriptions.forEach(sub => { sub.unsubscribe(); });
  }

  get identifiantJuridictionValeur(): string {
    return this.formulaireService.getRootForm().get('ielst').value;
  }

  public get formulaire(): UntypedFormGroup {
    return this.formulaireService.getRootForm().get('syntheseBav') as UntypedFormGroup;
  }

  get detailBavs() {
    return this.rootForm.get('bav').get('detailBavs') as UntypedFormArray;
  }

}